import React from 'react';
import { IProps as IBlockProps } from './DonationConfirmationBlock.interface';
import { DonationConfirmationBlock } from './DonationConfirmationBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

export interface IBlockInputProps {
    heading?: string;
    content?: string;
    parentClass?: string;
    anchorId?: string;
    image?: any;
    background: ThemeColors;
    [key: string]: any; // Allow passthrough of other props
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
    const {
        background,
        heading,
        content,
        parentClass,
        image,
        anchorId,
        ...rest
    } = input;

    return {
        title: heading,
        description: content,
        backgroundColor: background || 'white',
        backgroundGradient: 'gradient-1',
        backgroundImage: image ? translation.mapImageProps(image) : undefined,
        paddingBottom: 'small',
        paddingTop: 'small',
        ...rest,
    };
};

const BlockTranslation: React.FC<IBlockInputProps> = (inputProps) => (
    <TranslationComponent
        inputProps={inputProps}
        TargetComponent={DonationConfirmationBlock}
        mapProps={mapInputToProps}
    />
);

export default BlockTranslation;
